var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { PeekBox, PeekInput, PeekStack, PeekTooltip, PeekTypography, } from "@piiqtechnologies/ui-components";
import { Info as InfoIcon } from "@piiqtechnologies/svg-icons";
const AccessDeviceLabelInput = (_a) => {
    var { label, infoText } = _a, props = __rest(_a, ["label", "infoText"]);
    return (React.createElement(PeekInput, Object.assign({}, props, { label: React.createElement(PeekStack, { direction: "row", spacing: 0.5 },
            React.createElement(PeekTypography, { variant: "h5" }, label),
            infoText && (React.createElement(PeekTooltip, { placement: "top-start", title: React.createElement(PeekTypography, null, infoText) },
                React.createElement(PeekBox, null,
                    React.createElement(InfoIcon, { height: 13, width: 13 }))))) })));
};
export default AccessDeviceLabelInput;
